import React from "react";
import TriggerCard from "./TriggerCard";

const TriggerManagement = ({
  triggers,
  onCreateTrigger,
  onEditTrigger,
  onDeactivateTrigger,
  onDeleteTrigger,
}) => {
  return (
    <div className="automation-section">
      <div className="automation-section-title">Automation Triggers</div>
      <div className="automation-triggers-header">
        <span className="automation-label">All Triggers</span>
        <button className="trigger-button" onClick={onCreateTrigger}>
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.5 2.5V12.5M2.5 7.5H12.5"
              stroke="rgba(255, 255, 255, 0.85)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Trigger</span>
        </button>
      </div>

      {/* Trigger Cards */}
      <div className="trigger-cards">
        {triggers.map((trigger) => (
          <TriggerCard
            key={trigger.id}
            trigger={trigger}
            onEdit={onEditTrigger}
            onDeactivate={onDeactivateTrigger}
            onDelete={onDeleteTrigger}
          />
        ))}
      </div>
    </div>
  );
};

export default TriggerManagement;
